import React from 'react'
import PropTypes from 'prop-types'
import PageTitle from '../features/ui/util/page_title'
import DefaultLayout from '../layouts/default_layout'
import { connect } from 'react-redux'
import { BREAKPOINT_EXTRA_SMALL, CX } from '../constants'
import BusinessFeaturesPanel from '../components/panel/business_features_panel'
import { me } from '../initial_state'
import Text from '../components/text'
import Button from '../components/button'

class BusinessCreatePage extends React.PureComponent {

  render() {
    const { children, isXS, page } = this.props
    
    const isThanks = page === 'business-join-thanks'
    const title = isThanks ? 'Thank You!' : 'List your Business'

    const containerClasses = CX({
      d: 1,
      bgPrimary: 1,
      w50PC: !isXS,
      minW460PX: !isXS,
      maxW640PX: !isXS,
      radiusSmall: !isXS,
      boxShadowModal: !isXS,
      mlAuto: !isXS,
      mrAuto: !isXS,
      mt15: !isXS,
      px15: !isXS,
      w100PC: isXS,
      px5: isXS,
      py15: 1,
    })

    const thanksClasses = CX({
      d: 1,
      w100PC: 1,
      px5: isXS,
      py15: isXS,
    })

    return (
      <DefaultLayout
        noRightSidebar
        showBackBtn
        showNormalSidebar
        title={title}
        page='business-create'
        noPullToRefresh
        sidebarChildren={!isXS ? <BusinessFeaturesPanel noPanel isThanks={isThanks} /> : undefined }
      >
        <PageTitle path={title} />
                
        <div className={containerClasses}>
          { isXS && !me && <Text weight='bold' size='extraExtraLarge' className={[_s.px10, _s.mt5, _s.mb15].join(' ')}>List your Business</Text> }
          { isXS && <BusinessFeaturesPanel noPanel isThanks={isThanks} /> }
          { !isThanks && children }
          {
            isThanks &&
            <div className={thanksClasses}>
              <Text size='extraExtraLarge' weigh='bold' className={[_s.mb15].join(' ')}>Success!</Text>
              <Text>Thank you for filling out the form. Your business is currently pending approval and will be reviewed shortly.</Text>
              <Button
                isBlock
                radiusSmall
                to='/businesses/dashboard'
                className={[_s.mt15].join(' ')}
              >
                <Text color='inherit' align='center' weight='medium'>View Business</Text>
              </Button>
            </div>
          }
        </div>

      </DefaultLayout>
    )
  }

}

const mapStateToProps = (state) => ({
  isXS: state.getIn(['settings', 'window_dimensions', 'width']) <= BREAKPOINT_EXTRA_SMALL,
})

BusinessCreatePage.propTypes = {
  children: PropTypes.node.isRequired,
}

export default connect(mapStateToProps)(BusinessCreatePage)